/**
 * RISKS-IMPORT.ROUTE
 * Upload existing document
 */
import NavFocus from "@/nav/nav.focus"
import PageHeader from "@/components/page-header"
import { RisksImport } from "../entities/risk/ui/RisksImport"
import { useAppSelector, useAppDispatch } from "@/core/root-reducer"
import riskStore from "../entities/risk/model/risk.store"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCircleInfo, faDownload, faSpinner } from "@fortawesome/free-solid-svg-icons"
import Button from "@/components/button"
import Link from "@/components/link"
import { useNavigate } from "react-router-dom"
import { t } from "i18next"
import { STATUS_LOADING } from "@/redux/_status.types"
import { useEffect } from "react"
import env from "@/env"

export default function RisksImportRoute() {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  // selectors
  const risks = useAppSelector(riskStore.selectors.list)
  const status = useAppSelector(riskStore.selectors.status)
  const _session = useAppSelector((state) => state._session)

  useEffect(() => {
    dispatch(riskStore.thunks.fetchValidatedAndSet(null))
  }, [dispatch])

  const hasRisks = risks.length > 0
  const isLoading = status === STATUS_LOADING
  const isSupervisor = _session.connectedAsSupervisor

  return (
    <NavFocus>
      <PageHeader
        title={
          isLoading
            ? t("Chargement en cours...")
            : hasRisks
              ? t("Document déjà présent")
              : t("Importer mon document existant")
        }
        subtitle={
          isLoading ? (
            t("Merci de patienter quelques instants.")
          ) : (
            <div className="flex justify-between items-center w-full">
              <span>
                {hasRisks && !isSupervisor
                  ? t(
                      "Un document existe déjà dans votre espace. Vous ne pouvez pas en importer un nouveau. Utilisez plutôt les outils de modification pour le mettre à jour."
                    )
                  : hasRisks && isSupervisor
                    ? t("Vous pouvez supprimer les risques existants pour en importer de nouveaux.")
                    : t("Uploadez votre document unique au format Excel dans IDTree.")}
              </span>
              <Link
                icon={faDownload}
                onClick={() => {
                  const a = document.createElement("a")
                  a.href = `${env.REACT_APP_URL_SPACE}/Downloads/DUERP-Exemple.xlsx`
                  a.download = "DUERP-Exemple.xlsx"
                  a.click()
                }}
                className="text-sm whitespace-nowrap ml-4">
                {t("Télécharger un exemple")}
              </Link>
            </div>
          )
        }
      />

      {isLoading ? (
        <div className="p-8 text-center text-gray-500 flex flex-col items-center gap-3">
          <FontAwesomeIcon icon={faSpinner} spin size="2x" className="text-gray-400 mb-2" />
          <p>{t("Chargement des risques en cours...")}</p>
        </div>
      ) : hasRisks ? (
        <div className="p-8 text-center text-gray-600 flex flex-col items-center gap-3">
          <FontAwesomeIcon icon={faCircleInfo} size="3x" className="text-blue-400 mb-2" />
          <div className="flex items-center gap-2 text-gray-500">
            <FontAwesomeIcon icon={faDownload} />
            <span>{t("Votre document est déjà importé.")}</span>
          </div>
          <Button className="primary" onClick={() => navigate("/home")}>
            {t("Retour à l'accueil")}
          </Button>
        </div>
      ) : (
        <RisksImport />
      )}
    </NavFocus>
  )
}
